var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hotel-profile-component',{on:{"update-title":_vm.changeTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }